import { useEffect, useState } from "react";
import type { GossipItem } from "@/mocks/gossip";
import { gossipItems } from "@/mocks/gossip";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ColumnStrip from "./components/ColumnStrip";
import NewsSection from "./components/NewsSection";
import HotBoard from "./components/HotBoard";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import ArticleModal from "./components/ArticleModal";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "爆料网上的「瓜」都是从哪里来的？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "爆料网的资讯主要来自公开社交动态、正规媒体通稿、节目与剧组官方物料，以及经多位目击者交叉核实的现场报料，并设有来源标注机制。",
      },
    },
    {
      "@type": "Question",
      name: "标着「实锤」和「传闻」有什么区别？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "「实锤」有官方声明或现场视频等直接证据支撑，「传闻」则来自单一路透或匿名信源，真实性仍在核实中。",
      },
    },
  ],
};

export default function Home() {
  const [active, setActive] = useState("all");
  const [current, setCurrent] = useState<GossipItem | null>(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jumpToFeed = (key: string) => {
    setActive(key);
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const relatedOf = (item: GossipItem) =>
    gossipItems.filter((i) => i.id !== item.id).slice(0, 3);

  return (
    <div className="bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Header />

      <main>
        <Hero lead={gossipItems[0]} onRead={setCurrent} />

        <NewsSection items={gossipItems} active={active} onCategory={setActive} onRead={setCurrent} />

        <ColumnStrip items={gossipItems} onSelect={jumpToFeed} />

        <HotBoard items={gossipItems} onRead={setCurrent} />

        <FaqSection />
      </main>

      <Footer />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 grid h-12 w-12 place-items-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl leading-none" aria-hidden="true"></i>
        </button>
      )}

      <ArticleModal
        item={current}
        related={current ? relatedOf(current) : []}
        onClose={() => setCurrent(null)}
        onPick={setCurrent}
      />
    </div>
  );
}